module.exports = __webpack_public_path__ + "static/media/bg45.e6dcb669.jpg";